import { getDefaultPath } from "../../urlSync";
import actions, { getView } from "./actions";

const preKeys = getDefaultPath();

const initState = {
  collapsed: window.innerWidth > 1220 ? true : false,
  view: getView(window.innerWidth),
  height: window.innerHeight,
  TopMenuOpen: false,
  openDrawer: false,
  openKeys: preKeys,
  current: preKeys,
  selectedLayout: '',
  currentLayoutsKeysNames:[]
};
console.log(initState,"initState")
export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.COLLPSE_CHANGE:
      return {
        ...state,
        collapsed: !state.collapsed
      };
    case actions.COLLPSE_OPEN_DRAWER:
      return {
        ...state,
        openDrawer: !state.openDrawer
      };
    case actions.TOGGLE_TOP_MENU:
      return {
        ...state,
        TopMenuOpen: !state.TopMenuOpen
      };
    case actions.TOGGLE_ALL:
      if (state.view !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height;
        return {
          ...state,
          collapsed: action.collapsed,
          view: action.view,
          height
        };
      }
      break;
    case actions.CHANGE_OPEN_KEYS:
      return {
        ...state,
        openKeys: action.openKeys
      };
    case actions.CHANGE_CURRENT:
      return {
        ...state,
        current: action.current
      };
    case actions.SELECT_LAYOUT:
      return {
        ...state,
        selectedLayout: action.selectedLayout,
      };
      case actions.SET_LAYOUTS_KEY_NAMES:
        return {
          ...state,
          currentLayoutsKeysNames: action.currentLayoutsKeysNames,
        };
    case actions.CLEAR_MENU:
      return {
        ...state,
        openKeys: [],
        current: []
      };
    default:
      return state;
  }
  return state;
}
